/*最初の演出*/
window.addEventListener("load", () => {
    const tl = gsap.timeline({
        defaults: { ease: "power2.inOut" }
    });

    // 赤が広がる
    tl.to(".page-overlay", {
        width: "100%",
        duration: 0.8
    })
        // サイトをこのタイミングでフェードイン
        .add(() => {
            const site = document.getElementById("site-wrap");
            site.style.visibility = "visible";
            gsap.to(site, { opacity: 1, duration: 0.8, ease: "power2.out" });
        })
        // その後 赤が右に抜ける
        .to(".page-overlay", {
            xPercent: 100,
            duration: 0.8,
            delay: 0.2,
            onComplete: () => {
                document.querySelector(".page-overlay").remove();
            }
        });
});


const swiperL = new Swiper(".swiper_l", {
    loop: true,
    parallax: true,
    direction: 'vertical',
    allowTouchMove: false,
    speed: 2000,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        reverseDirection: true,
    },
});

const swiperR = new Swiper(".swiper_r", {
    loop: true,
    parallax: true,
    direction: 'vertical',
    allowTouchMove: false,
    speed: 2000,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false
    },
});

/*テキスト無限ループ*/
function calculateLoopAnimationSpeed() {
    const targets = document.querySelectorAll('.js-tick');
    if (!targets.length) {
        return;
    }

    const distance = window.innerWidth;
    const mql = window.matchMedia('(min-width: 801px)');
    const time = mql.matches ? 18 : 9; //ここで時間を調整
    const speed = distance / time;

    targets.forEach((target) => {
        const tickElems = target.querySelectorAll('.js-tick-item');
        if (!tickElems.length) {
            return;
        }

        const total = tickElems.length - 1;

        tickElems.forEach((el, i) => {
            const elWidth = el.clientWidth;
            const elTime = Math.floor(elWidth / speed);
            el.style.setProperty('--tick-duration', `${elTime}s`);
            el.style.setProperty('--tick-delay', `${elTime / -2}s`);
        });
    });
}

/*TOP company slider*/
const container = document.querySelector('.top_company_slider__swiper');
const wrapper   = container.querySelector('.top_company_slider__swiper_wrapper');
const slides    = Array.from(wrapper.children);

// コンテナ幅の2倍以上になるまで複製（継ぎ目ゼロにするコツ）
let target = container.clientWidth * 2;
while (wrapper.scrollWidth < target) {
    slides.forEach(s => wrapper.appendChild(s.cloneNode(true)));
}
// 逆方向に
container.classList.add('reverse');

/*画像パララックス*/
gsap.registerPlugin(ScrollTrigger);

// まず少し拡大しておく（はみ出し防止）
gsap.set(".top_about_section .top_about_section__inner__img img", {
    scale: 1.15
});

// レスポンシブ対応
const mm = gsap.matchMedia();
mm.add(
    {
        isSP: "(max-width: 768px)",
        isPC: "(min-width: 769px)"
    },
    (ctx) => {
        const { isSP } = ctx.conditions;

        // 動きの大きさ（px）
        const SHIFT_IMG1 = isSP ? 150 : 300; // ← 値を増やした
        const SHIFT_IMG2 = isSP ? 120 : 250; // こちらはそのままでもOK

        // ScrollTrigger タイムライン
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".top_about_section",
                start: "top bottom",   // 画面下に入ったら開始
                end: "bottom top",     // 上に抜けるまで
                scrub: true,           // スクロールに追従
                invalidateOnRefresh: true
                // pin: true,          // 固定演出したければON
            },
            defaults: { ease: "none" }
        });

        // .img01 を上方向へ大きく動かす
        tl.fromTo(".top_about_section .img01",
            { y: -SHIFT_IMG1 },
            { y:  SHIFT_IMG1 }
        );

        // .img02 を下方向へ大きく動かす（逆方向）
        tl.fromTo(".top_about_section .img02",
            { y:  SHIFT_IMG2 },
            { y: -SHIFT_IMG2 },
            0 // 同時に開始
        );
    }
);




/*タイトルラインアニメーション*/
document.addEventListener("DOMContentLoaded", () => {
    const targets = document.querySelectorAll("h2.top_h2 .top_h2__top");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("animate");
                observer.unobserve(entry.target); // 一度だけ
            }
        });
    }, { threshold: 0.5 });

    targets.forEach(el => observer.observe(el));
});
